import * as React from 'react';

interface IProps {
    showNextYearPremium: boolean;
    localNumber: string;
    abroadNumber: string
}

export class NotesBeforeClaimSubmission extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    public render(): React.ReactNode {
        return (
            <>
                <p className="font-weight-semi-bold fs-18">A few things to note before you make your claim:</p>
                <ul>
                    <li>We share data and record suspicions of fraud with other organisations, fraud prevention agencies and their members to prevent financial crime</li>
                    <li>To help us and the supplier we may appoint to handle your claim, we'll also share information with them so that we can provide the best possible service</li>
                    <li>If your claim is urgent, you can call us on{' '}
                        <a className="a-bold" href={`tel:+44 ${this.props.localNumber}`}>{this.props.localNumber}</a> or{' '}
                        <a className="a-bold" href={`tel:+44 ${this.props.abroadNumber}`}>(+44) {this.props.abroadNumber}</a> 24/7
                    </li>
                    {this.props.showNextYearPremium &&
                        <li>Making a claim could increase your next year premium</li>
                    }
                </ul>
            </>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/claims/NotesBeforeClaimSubmission.tsx